import React from 'react'
import styled from 'styled-components'
import { colors } from '../../../styles/colors';

const SideCardContainer = styled.div`
    width: 420px;
    height: 400px;

    border: 1px solid ${colors.dark_blue};
    padding: 5rem;
    padding-bottom: 7rem;

    display: flex;
    flex-direction: column;
    justify-content: space-between;

    @media (min-width: 960px) and (max-width: 1439.98px) {
        padding: 5rem 2.5rem 7rem 2.5rem;
    }
    @media (min-width: 960px) and (max-width: 1439.98px) {
        padding: 2rem;
        padding-bottom: 7rem;
    }
    @media (min-width: 768px) and (max-width: 959.98px) {
        width: 280px;
        margin: 0;
        :first-child {
            margin-right: 152px;
        }
    }
    @media (max-width: 767.98px) {
        display: none;
    }

    // INCLUDED CLASSES:
    
    .picture {
        width: 100%;
        height: 120px;

        background: url(${props => props.partner_picture}) no-repeat 50% 50%;
        background-size: contain;
    }
    .description {
        font-family: 'SF UI Text', sans-serif;
        font-weight: 300;
        font-size: 2.5rem;
        line-height: 150%;
        text-align: center;
        margin-top: 2rem;

        @media (max-width: 960px) {
            font-size: 2rem;
        }
    }
`
export const SideCard = ({data}) => {
    return (
        <SideCardContainer partner_picture={data.partner_picture} className='side-card'>
            <div className="picture" />
            <p className="description"> {data.partner_description} </p>
        </SideCardContainer>
    )
}

